import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import rootReducer from './reducers';

const enhancers = [];

if (process.env.mode === 'dev') {
    const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

    if (typeof devToolsExtension === 'function') {
        enhancers.push(devToolsExtension())
    }
}

const composedEnhancers = compose(
    applyMiddleware(
        thunkMiddleware,
    ),
    ...enhancers
)

export const store = createStore(
    rootReducer,
    composedEnhancers
);


// WEBPACK FOOTER //
// ./src/redux/store.js